// src/Pages/Forms/CreateFormPage.tsx

import React from "react";
import usePostHook from "../../customHooks/usePostHook";
import APIS from "../../constant/Endpoint";
import { useForm } from "react-hook-form";
// @ts-ignore
import { FormLayout } from "@careinfo/layout";
import FormsForm from "../../Components/Forms/FormsForm";

const CreateFormPage = () => {
  const { mutateAsync: createForm, isPostLoading } = usePostHook({
    queryKey: ["forms"],
    navigateURL: "/form-builder/forms",
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const handleCreate = async (formData: any) => {
    const payload = {
      title: formData.title,
      name: formData.title,
      form_type: "simple_form",
    };

    try {
      await createForm({
        url: APIS.FORM,
        formData: payload,
      });
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <FormLayout
      handleSubmit={handleSubmit}
      handleFormSubmit={handleCreate}
      buttonLabel="Create Form"
      isLoading={isPostLoading}
    >
      <FormsForm register={register} />
    </FormLayout>
  );
};

export default CreateFormPage;
